import { AuthSession } from 'aws-amplify/auth';
import { AuthAction, AuthActionTypes } from './actions';

export interface AuthState {
  isLoggedIn: boolean;
  session: AuthSession | null;
  error: string | null;
  loading: boolean;
}

const initialState: AuthState = {
  isLoggedIn: false,
  session: null,
  error: null,
  loading: false,
};

export default function authReducer(state = initialState, action: AuthAction) {
  switch (action.type) {
    case AuthActionTypes.LOGIN_WITH_GOOGLE_REQUEST:
      return { ...state, loading: true };

    case AuthActionTypes.LOGIN_WITH_GOOGLE_SUCCESS:
      return { ...state, isLoggedIn: true, session: action.payload, loading: false };

    case AuthActionTypes.LOGOUT_REQUEST:
      return { ...state, loading: true };

    case AuthActionTypes.LOGOUT_SUCCESS:
      return { ...state, session: null, isLoggedIn: false, loading: false };

    case AuthActionTypes.LOGIN_WITH_GOOGLE_ERROR:
      return { ...state, error: action.payload, loading: false };

    case AuthActionTypes.SIGN_IN_WITH_COGNITO_REQUEST:
      return { ...state, loading: true };

    case AuthActionTypes.SIGN_IN_WITH_COGNITO_SUCCESS:
      return { ...state, session: action.payload, isLoggedIn: true, loading: false };

    case AuthActionTypes.SIGN_IN_WITH_COGNITO_ERROR:
      return { ...state, error: action.payload, loading: false };

    case AuthActionTypes.SIGN_OUT_WITH_COGNITO_REQUEST:
      return { ...state, loading: true };

    case AuthActionTypes.SIGN_OUT_WITH_COGNITO_SUCCESS:
      return { ...state, session: null, isLoggedIn: false, loading: false };

    case AuthActionTypes.SIGN_OUT_WITH_COGNITO_ERROR:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
}
